import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
(function () {
  if (typeof window === 'undefined') return;
  // If the pixel script is already in the DOM, do nothing
  if (document.querySelector('script[src*="fbevents.js"]')) return;
  const n: any = (window as any).fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
  };
  if (!(window as any)._fbq) (window as any)._fbq = n;
  n.push = n;
  n.loaded = true;
  n.version = '2.0';
  n.queue = [];
  const script = document.createElement('script');
  script.async = true;
  script.src = 'https://connect.facebook.net/en_US/fbevents.js';
  document.head.appendChild(script);
  (window as any).fbq('set', 'autoConfig', false, '2050915922356247');
  (window as any).fbq('init', '2050915922356247');
  (window as any).fbq('track', 'PageView');
})();
render(<App data-id="element-207" />, document.getElementById('root'));